module.exports = [
  {
    title: 'Администрирование',
    state: 'Administration'
  },
  {
    title: 'Учётные записи',
    state: 'Users'
  }
]
